<template>

  <Head title="Detail Pegawai" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div class="min-h-screen bg-gray-50">
        <div class="px-4 py-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <Breadcrumbs :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            { name: 'Pegawai', href: route('pegawai.index') },
            { name: pegawaiNama, href: route('pegawai.detail', pegawaiIdpegawai) },
          ]" />

          <div class="mb-8">
            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h1 class="text-3xl font-bold text-gray-900">Detail Pegawai</h1>
                <p class="mt-2 text-lg text-gray-600">
                  Informasi lengkap data pegawai
                </p>
              </div>
              <div class="flex flex-wrap gap-2 mt-4 sm:mt-0">

                <button v-if="$page.props.can?.pegawai_edit" @click="openEditModal"
                  class="inline-flex items-center justify-center px-4 py-2.5 text-sm font-semibold text-white bg-indigo-600 border border-transparent rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
                  title="Edit Pegawai">
                  <i class="mr-2 fa-solid fa-edit"></i>
                  Edit pegawai
                </button>
                <button v-if="$page.props.can?.pegawai_delete" @click="deletePegawai(pegawaiIdpegawai)"
                  class="inline-flex items-center justify-center px-4 py-2.5 text-sm font-semibold text-white bg-red-600 border border-transparent rounded-lg shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
                  title="Hapus Pegawai">
                  <i class="mr-2 fa-solid fa-trash"></i>
                  Hapus
                </button>
              </div>
            </div>
          </div>

          <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
            <!-- Photo Column -->
            <div class="order-2 lg:order-1">
              <div class="bg-white border border-gray-200">
                <div
                  class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 sm:px-6 sm:py-4">
                  <h2 class="flex items-center text-lg font-bold text-white sm:text-xl">
                    <i class="mr-2 fa-solid fa-image sm:mr-3"></i>
                    Foto
                  </h2>
                </div>
                <div class="p-4 sm:p-6">
                  <div v-if="filePath && filePath.length && isImage(filePath[0])">
                    <div v-for="(file, index) in filePath" :key="index" class="mb-4">
                      <div
                        class="relative overflow-hidden bg-gray-100 border border-gray-200 rounded-lg shadow-sm aspect-square">
                        <img :src="file" alt="Foto Pegawai" class="object-cover w-full h-full" />
                        <button v-if="$page.props.can?.pegawai_edit" @click="showFotoModal = true"
                          class="absolute flex items-center px-3 py-2 text-xs font-medium text-white transition-colors duration-200 bg-indigo-600 border border-indigo-700 rounded-lg shadow-sm top-3 right-3 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          title="Edit Foto">
                          <i class="mr-1 fa-solid fa-edit"></i>
                          Edit
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div
                      class="relative flex flex-col items-center justify-center h-64 border-2 border-gray-200 border-dashed rounded-lg bg-gray-50">
                      <i class="mb-3 text-4xl text-gray-400 fa-solid fa-user-circle"></i>
                      <span class="text-sm text-gray-500">Belum ada foto</span>
                      <button v-if="$page.props.can?.pegawai_edit" @click="showFotoModal = true"
                        class="inline-flex items-center px-3 py-2 mt-3 text-xs font-medium text-white transition-colors duration-200 bg-indigo-600 border border-transparent rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        title="Upload Foto">
                        <i class="mr-1 fa-solid fa-upload"></i>
                        Upload Foto
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Information Section -->
            <div class="order-1 lg:order-2 lg:col-span-2">
              <div class="bg-white border border-gray-200">
                <div
                  class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 sm:px-6 sm:py-4">
                  <h2 class="flex items-center text-lg font-bold text-white sm:text-xl">
                    <i class="mr-2 fa-solid fa-user sm:mr-3"></i>
                    Informasi
                  </h2>
                </div>
                <div class="p-4 sm:p-6">
                  <dl class="divide-y divide-gray-200">
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
                      <dt class="flex items-center text-sm font-semibold text-gray-900">
                        <i class="mr-2 text-indigo-600 fa-solid fa-user"></i>
                        Nama Pegawai
                      </dt>
                      <dd class="text-sm font-medium text-gray-700 sm:col-span-2">
                        {{ pegawai.data.nama || "-" }}
                      </dd>
                    </div>
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
                      <dt class="flex items-center text-sm font-semibold text-gray-900">
                        <i class="mr-2 text-indigo-600 fa-solid fa-id-card"></i>
                        NIP
                      </dt>
                      <dd class="text-sm text-gray-700 sm:col-span-2">
                        {{ pegawai.data.nip || "-" }}
                      </dd>
                    </div>

                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
                      <dt class="flex items-center text-sm font-semibold text-gray-900">
                        <i class="mr-2 text-indigo-600 fa-solid fa-envelope"></i>
                        Email
                      </dt>
                      <dd class="text-sm text-gray-700 sm:col-span-2">
                        <a v-if="pegawai.data.email" :href="`mailto:${pegawai.data.email}`"
                          class="text-indigo-600 transition-colors duration-200 hover:text-indigo-800 hover:underline">
                          {{ pegawai.data.email }}
                        </a>
                        <span v-else>-</span>
                      </dd>
                    </div>
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
                      <dt class="flex items-center text-sm font-semibold text-gray-900">
                        <i class="mr-2 text-green-600 fa-brands fa-whatsapp"></i>
                        No WhatsApp
                      </dt>
                      <dd class="text-sm text-gray-700 sm:col-span-2">
                        <a v-if="pegawai.data.nohp" :href="`https://wa.me/${pegawai.data.nohp.replace(
                          /\D/g,
                          ''
                        )}`" target="_blank"
                          class="text-green-600 transition-colors duration-200 hover:text-green-800 hover:underline">
                          {{ pegawai.data.nohp }}
                        </a>
                        <span v-else>-</span>
                      </dd>
                    </div>
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3">
                      <dt class="flex items-center text-sm font-semibold text-gray-900">
                        <i class="mr-2 text-indigo-600 fa-solid fa-university"></i>
                        Fakultas
                      </dt>
                      <dd class="text-sm text-gray-700 sm:col-span-2">
                        <span
                          class="inline-flex px-3 py-1 text-xs font-medium text-indigo-800 bg-indigo-100 rounded-full">
                          {{ pegawai.data.fakultas?.name || "-" }}
                        </span>
                      </dd>
                    </div>
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3" v-if="pegawai.data.departemen">
                      <dt class="flex items-center text-sm font-semibold text-gray-900">
                        <i class="mr-2 text-indigo-600 fa-solid fa-building"></i>
                        Departemen
                      </dt>
                      <dd class="text-sm text-gray-700 sm:col-span-2">
                        <span
                          class="inline-flex px-3 py-1 text-xs font-medium text-green-800 bg-green-100 rounded-full">
                          {{ pegawai.data.departemen?.name || "-" }}
                        </span>
                      </dd>
                    </div>
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3" v-if="pegawai.data.prodi">
                      <dt class="flex items-center text-sm font-semibold text-gray-900">
                        <i class="mr-2 text-indigo-600 fa-solid fa-graduation-cap"></i>
                        Program Studi
                      </dt>
                      <dd class="text-sm text-gray-700 sm:col-span-2">
                        <span
                          class="inline-flex px-3 py-1 text-xs font-medium text-purple-800 bg-purple-100 rounded-full">
                          {{ pegawai.data.prodi?.name || "-" }}
                        </span>
                      </dd>
                    </div>

                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3" v-if="pegawai.data.pendidikan">
                      <dt class="flex items-center text-sm font-semibold text-gray-900">
                        <i class="mr-2 text-indigo-600 fa-solid fa-book"></i>
                        Pendidikan
                      </dt>
                      <dd class="text-sm text-gray-700 sm:col-span-2">
                        <div v-html="pegawai.data.pendidikan" class="prose-sm prose max-w-none"></div>
                      </dd>
                    </div>
                    <div class="grid grid-cols-1 gap-4 py-4 sm:grid-cols-3" v-if="pegawai.data.jabatan">
                      <dt class="flex items-center text-sm font-semibold text-gray-900">
                        <i class="mr-2 text-indigo-600 fa-solid fa-briefcase"></i>
                        Jabatan
                      </dt>
                      <dd class="text-sm text-gray-700 sm:col-span-2">
                        {{ pegawai.data.jabatan?.name || "-" }}
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal Edit Pegawai -->
          <div v-if="showEditModal"
            class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
            <div class="relative w-full max-w-4xl mx-auto bg-white shadow-xl rounded-xl max-h-[90vh] overflow-y-auto">
              <div
                class="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl">
                <div class="flex items-center justify-between">
                  <h3 class="text-lg font-bold text-white">
                    <i class="mr-2 fa-solid fa-edit"></i>
                    Edit Data Pegawai
                  </h3>
                  <button @click="showEditModal = false"
                    class="text-white rounded-lg hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                      </path>
                    </svg>
                  </button>
                </div>
              </div>
              <form @submit.prevent="submitEdit">
                <div class="p-6 space-y-6">
                  <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
                    <div>
                      <label class="block mb-2 text-sm font-semibold text-gray-700">
                        <i class="mr-2 fa-solid fa-user"></i>
                        Nama Pegawai
                      </label>
                      <input type="text" v-model="editForm.nama" :class="{
                        'w-full px-4 py-3 transition-colors duration-200 border rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500': true,
                        'border-red-300 focus:ring-red-500 focus:border-red-500':
                          validationErrors.nama,
                        'border-gray-300': !validationErrors.nama,
                      }" placeholder="Masukkan nama pegawai" required />
                      <p v-if="validationErrors.nama" class="mt-1 text-sm text-red-600">
                        {{ validationErrors.nama[0] }}
                      </p>
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-semibold text-gray-700">
                        <i class="mr-2 fa-solid fa-id-card"></i>
                        NIP
                      </label>
                      <input type="text" v-model="editForm.nip" :class="{
                        'w-full px-4 py-3 transition-colors duration-200 border rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500': true,
                        'border-red-300 focus:ring-red-500 focus:border-red-500':
                          validationErrors.nip,
                        'border-gray-300': !validationErrors.nip,
                      }" placeholder="Masukkan NIP" />
                      <p v-if="validationErrors.nip" class="mt-1 text-sm text-red-600">
                        {{ validationErrors.nip[0] }}
                      </p>
                    </div>

                    <div>
                      <label class="block mb-2 text-sm font-semibold text-gray-700">
                        <i class="mr-2 fa-solid fa-envelope"></i>
                        Email
                      </label>
                      <input type="email" v-model="editForm.email" :class="{
                        'w-full px-4 py-3 transition-colors duration-200 border rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500': true,
                        'border-red-300 focus:ring-red-500 focus:border-red-500':
                          validationErrors.email,
                        'border-gray-300': !validationErrors.email,
                      }" placeholder="Masukkan email" />
                      <p v-if="validationErrors.email" class="mt-1 text-sm text-red-600">
                        {{ validationErrors.email[0] }}
                      </p>
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-semibold text-gray-700">
                        <i class="mr-2 fa-solid fa-phone"></i>
                        No WhatsApp
                      </label>
                      <input type="text" v-model="editForm.nohp" :class="{
                        'w-full px-4 py-3 transition-colors duration-200 border rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500': true,
                        'border-red-300 focus:ring-red-500 focus:border-red-500':
                          validationErrors.nohp,
                        'border-gray-300': !validationErrors.nohp,
                      }" placeholder="Masukkan nomor WhatsApp" />
                      <p v-if="validationErrors.nohp" class="mt-1 text-sm text-red-600">
                        {{ validationErrors.nohp[0] }}
                      </p>
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-semibold text-gray-700">
                        <i class="mr-2 fa-solid fa-briefcase"></i>
                        Jabatan
                      </label>
                      <select v-model="editForm.jabatan" :class="{
                        'w-full px-4 py-3 transition-colors duration-200 border rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500': true,
                        'border-red-300 focus:ring-red-500 focus:border-red-500':
                          validationErrors.jabatan,
                        'border-gray-300': !validationErrors.jabatan,
                      }">
                        <option value="">Pilih Jabatan</option>
                        <option v-for="jab in jabatans.data" :key="jab.id" :value="jab.id">
                          {{ jab.namajabatan }}
                        </option>
                      </select>
                      <p v-if="validationErrors.jabatan" class="mt-1 text-sm text-red-600">
                        {{ validationErrors.jabatan[0] }}
                      </p>
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-semibold text-gray-700">
                        <i class="mr-2 fa-solid fa-university"></i>
                        Fakultas
                      </label>
                      <select v-model="editForm.fakultas_id" @change="getDepartemen" :class="{
                        'w-full px-4 py-3 transition-colors duration-200 border rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500': true,
                        'border-red-300 focus:ring-red-500 focus:border-red-500':
                          validationErrors.fakultas_id,
                        'border-gray-300': !validationErrors.fakultas_id,
                      }">
                        <option value="">Pilih Fakultas</option>
                        <option v-for="fakultas in faculties.data.data" :key="fakultas.id" :value="fakultas.id">
                          {{ fakultas.singkatan || fakultas.name }}
                        </option>
                      </select>
                      <p v-if="validationErrors.fakultas_id" class="mt-1 text-sm text-red-600">
                        {{ validationErrors.fakultas_id[0] }}
                      </p>
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-semibold text-gray-700">
                        <i class="mr-2 fa-solid fa-building"></i>
                        Departemen
                      </label>
                      <select v-model="editForm.departemen_id" @change="getProdi" :class="{
                        'w-full px-4 py-3 transition-colors duration-200 border rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500': true,
                        'border-red-300 focus:ring-red-500 focus:border-red-500':
                          validationErrors.departemen_id,
                        'border-gray-300': !validationErrors.departemen_id,
                      }">
                        <option value="">Pilih Departemen</option>
                        <option v-for="departemen in localDepartemen" :key="departemen.id" :value="departemen.id">
                          {{ departemen.name }}
                        </option>
                      </select>
                      <p v-if="validationErrors.departemen_id" class="mt-1 text-sm text-red-600">
                        {{ validationErrors.departemen_id[0] }}
                      </p>
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-semibold text-gray-700">
                        <i class="mr-2 fa-solid fa-graduation-cap"></i>
                        Program Studi
                      </label>
                      <select v-model="editForm.prodi_id" :class="{
                        'w-full px-4 py-3 transition-colors duration-200 border rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500': true,
                        'border-red-300 focus:ring-red-500 focus:border-red-500':
                          validationErrors.prodi_id,
                        'border-gray-300': !validationErrors.prodi_id,
                      }">
                        <option value="">Pilih Program Studi</option>
                        <option v-for="prodi in localProdi" :key="prodi.id" :value="prodi.id">
                          {{ prodi.jenjang }} | {{ prodi.name }}
                        </option>
                      </select>
                      <p v-if="validationErrors.prodi_id" class="mt-1 text-sm text-red-600">
                        {{ validationErrors.prodi_id[0] }}
                      </p>
                    </div>
                  </div>

                </div>
                <div class="px-6 py-4 border-t border-gray-200 bg-gray-50 rounded-b-xl">
                  <div class="flex justify-end space-x-3">
                    <button type="button" @click="showEditModal = false"
                      class="px-6 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200">
                      <i class="mr-2 fa-solid fa-times"></i>
                      Batal
                    </button>
                    <button type="submit"
                      class="px-6 py-2.5 text-sm font-semibold text-white bg-indigo-600 border border-transparent rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200">
                      <i class="mr-2 fa-solid fa-save"></i>
                      Simpan Perubahan
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!-- Modal Upload Foto -->
          <div v-if="showFotoModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div class="relative w-full max-w-md mx-4 bg-white shadow-xl rounded-xl">
              <div
                class="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl">
                <div class="flex items-center justify-between">
                  <h3 class="text-lg font-bold text-white">
                    <i class="mr-2 fa-solid fa-image"></i>
                    Upload Foto
                  </h3>
                  <button @click="showFotoModal = false"
                    class="text-white rounded-lg hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12">
                      </path>
                    </svg>
                  </button>
                </div>
              </div>
              <form @submit.prevent="submitFoto">
                <div class="p-6">
                  <div class="space-y-4">
                    <div>
                      <label class="block mb-2 text-sm font-semibold text-gray-700">
                        <i class="mr-2 fa-solid fa-upload"></i>
                        Pilih Foto
                      </label>
                      <input type="file" @change="onFotoChange" accept="image/*"
                        class="w-full px-4 py-3 transition-colors duration-200 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
                        required />
                      <p class="mt-2 text-xs text-gray-500">
                        Format yang didukung: JPG, JPEG, PNG, GIF. Maksimal 2MB.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="px-6 py-4 border-t border-gray-200 bg-gray-50 rounded-b-xl">
                  <div class="flex justify-end space-x-3">
                    <button type="button" @click="showFotoModal = false"
                      class="px-6 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200">
                      <i class="mr-2 fa-solid fa-times"></i>
                      Batal
                    </button>
                    <button type="submit"
                      class="px-6 py-2.5 text-sm font-semibold text-white bg-indigo-600 border border-transparent rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200">
                      <i class="mr-2 fa-solid fa-upload"></i>
                      Upload Foto
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { defineProps, watch, ref, computed } from "vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import Header from "@/Components/Header.vue";
import Container from "@/Layouts/Container.vue";
import { router, useForm } from "@inertiajs/vue3";
import Swal from "sweetalert2";

const props = defineProps({
  pegawai: { type: Object, required: true },
  faculties: { type: Object, required: true },
  departments: { type: Object, required: true },
  studyPrograms: { type: Object, required: true },
  jabatans: { type: Object, required: true },

});

const pegawaiData = computed(() => {
  if (!props.pegawai) return null;
  if (Array.isArray(props.pegawai.data)) return props.pegawai.data[0] || null;
  return props.pegawai.data || null;
});
const pegawaiNama = computed(() => pegawaiData.value?.nama || "-");
const pegawaiIdpegawai = computed(() => pegawaiData.value?.idpegawai || "-");

const filePath = ref([]);
if (pegawaiData.value && pegawaiData.value.foto) {
  let fotoUrl = pegawaiData.value.foto;
  if (
    fotoUrl &&
    !/^https?:\/\//.test(fotoUrl) &&
    !fotoUrl.startsWith("/storage")
  ) {
    fotoUrl = "/storage/" + fotoUrl;
  }
  filePath.value = [fotoUrl];
}

watch(
  () => props.pegawai,
  (newPegawai) => {
    let data = null;
    if (Array.isArray(newPegawai.data)) data = newPegawai.data[0] || null;
    else data = newPegawai.data || null;
    if (data && data.foto) {
      let fotoUrl = data.foto;
      if (
        fotoUrl &&
        !/^https?:\/\//.test(fotoUrl) &&
        !fotoUrl.startsWith("/storage")
      ) {
        fotoUrl = "/storage/" + fotoUrl;
      }
      filePath.value = [fotoUrl];
    } else filePath.value = [];
  }
);

function isImage(p) {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(p);
}

const showFotoModal = ref(false);

const fotoFile = ref(null);
function onFotoChange(e) {
  fotoFile.value = e.target.files[0];
}

async function submitFoto() {
  if (!fotoFile.value) {
    Swal.fire({
      title: "Peringatan!",
      text: "Silakan pilih foto terlebih dahulu.",
      icon: "warning",
      confirmButtonText: "OK",
    });
    return;
  }
  const formData = new FormData();
  formData.append("foto", fotoFile.value);
  router.post(route("pegawai.updatefoto", pegawaiIdpegawai.value), formData, {
    onSuccess: () => {
      showFotoModal.value = false;
      fotoFile.value = null;
      router.visit(route("pegawai.detail", pegawaiIdpegawai.value), {
        replace: true,
      });
    },
    onError: (errors) => {
      Swal.fire({
        title: "Gagal!",
        text: errors.foto || "Terjadi kesalahan saat mengupload foto.",
        icon: "error",
        confirmButtonText: "OK",
      });
    },
  });
}

const showEditModal = ref(false);
const editForm = ref({
  nama: pegawaiData.value?.nama || "",
  nip: pegawaiData.value?.nip || "",
  email: pegawaiData.value?.email || "",
  nohp: pegawaiData.value?.nohp || "",
  pendidikan: pegawaiData.value?.pendidikan || "",
  jabatan: pegawaiData.value?.jabatan?.id || "",
  fakultas_id: pegawaiData.value?.fakultas?.id || "",
  departemen_id: pegawaiData.value?.departemen?.id || "",
  prodi_id: pegawaiData.value?.prodi?.id || "",
});

const validationErrors = ref({});
const localDepartemen = ref([]);
const localProdi = ref([]);

function openEditModal() {
  editForm.value = {
    nama: pegawaiData.value?.nama || "",
    nip: pegawaiData.value?.nip || "",
    email: pegawaiData.value?.email || "",
    nohp: pegawaiData.value?.nohp || "",
    pendidikan: pegawaiData.value?.pendidikan || "",
    jabatan: pegawaiData.value?.jabatan?.id || "",
    fakultas_id: pegawaiData.value?.fakultas?.id || "",
    departemen_id: pegawaiData.value?.departemen?.id || "",
    prodi_id: pegawaiData.value?.prodi?.id || "",
  };
  validationErrors.value = {};
  if (editForm.value.fakultas_id)
    loadDepartemenForEdit(editForm.value.fakultas_id);
  if (editForm.value.departemen_id)
    loadProdiForEdit(editForm.value.departemen_id);
  showEditModal.value = true;
}

const getDepartemen = (event) => {
  editForm.value.fakultas_id = event.target.value;
  editForm.value.departemen_id = "";
  editForm.value.prodi_id = "";
  localProdi.value = [];
  if (editForm.value.fakultas_id) {
    fetch(route("jurusan.show", editForm.value.fakultas_id))
      .then((r) => r.json())
      .then(
        (d) => (localDepartemen.value = Array.isArray(d.data) ? d.data : [])
      )
      .catch(() => (localDepartemen.value = []));
  } else localDepartemen.value = [];
};

const getProdi = (event) => {
  editForm.value.departemen_id = event.target.value;
  editForm.value.prodi_id = "";
  if (editForm.value.departemen_id) {
    fetch(route("prodi.show", editForm.value.departemen_id))
      .then((r) => r.json())
      .then((d) => (localProdi.value = Array.isArray(d.data) ? d.data : []))
      .catch(() => (localProdi.value = []));
  } else localProdi.value = [];
};

const loadDepartemenForEdit = (fakultasId) => {
  if (fakultasId) {
    fetch(route("jurusan.show", fakultasId))
      .then((r) => r.json())
      .then(
        (d) => (localDepartemen.value = Array.isArray(d.data) ? d.data : [])
      )
      .catch(() => (localDepartemen.value = []));
  } else localDepartemen.value = [];
};

const loadProdiForEdit = (departemenId) => {
  if (departemenId) {
    fetch(route("prodi.show", departemenId))
      .then((r) => r.json())
      .then((d) => (localProdi.value = Array.isArray(d.data) ? d.data : []))
      .catch(() => (localProdi.value = []));
  } else localProdi.value = [];
};

function submitEdit() {
  validationErrors.value = {};
  router.put(route("pegawai.update", pegawaiIdpegawai.value), editForm.value, {
    onSuccess: () => {
      showEditModal.value = false;
      validationErrors.value = {};
      router.visit(route("pegawai.detail", pegawaiIdpegawai.value), {
        replace: true,
      });
    },
    onError: (errors) => {
      validationErrors.value = errors;
      const errorMessages = Object.values(errors).flat().join("\n");
      Swal.fire({
        title: "Gagal!",
        text: errorMessages || "Terjadi kesalahan saat memperbarui data.",
        icon: "error",
        confirmButtonText: "OK",
      });
    },
  });
}

function deletePegawai(id) {
  Swal.fire({
    title: "Apakah Anda yakin?",
    text: "Data pegawai akan dihapus permanen!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc3545",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Ya, Hapus!",
    cancelButtonText: "Batal",
  }).then((result) => {
    if (result.isConfirmed) {
      const form = useForm({});
      form.delete(route("pegawai.destroy", id), {
        onSuccess: () => {
          router.visit(route("pegawai.index"));
        },
        onError: () => {
          Swal.fire({
            title: "Gagal!",
            text: "Terjadi kesalahan saat menghapus data.",
            icon: "error",
            confirmButtonText: "OK",
          });
        },
      });
    }
  });
}
</script>
